import { ContainerStyleInterface } from "./icon_container_style_interface";

export const iconContainerDefaultStyle: ContainerStyleInterface = {
    backgroundColor: "white",
    backgroundHoverColor: "grey-lightest",
    backgroundFocusColor: "grey-lightest",
    size: 10,
};
